import { connect } from 'react-redux';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import ConfirmationButton from '../../../ui/confirmationButton/ConfirmationButton';
import { InformationSVG } from '../../../../svgComponents/informationSVG/index';
import IwLink from '../../../../iwRouter/IwLink';
import { MainSectionWrapper } from '../../../pageStructure/mainSectionWrapper/index';
import { OPEN_MODAL } from '../../../../iwModals/Modals.actions';

import messages from './MissingDocsView.messages';
import styles from './MissingDocsView.module.css';
import pendingViewStyles from '../PendingView.module.css';
import { Dispatch } from 'redux';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    openHelpModal: () => dispatch({ type: OPEN_MODAL, id: 'HelpModal' })
});

type PropsFromRedux = ReturnType<typeof mapDispatchToProps>;

const MissingDocsView = ({ openHelpModal }: PropsFromRedux) => (
    <MainSectionWrapper>
        <div
            className={pendingViewStyles.pendingStatus}
            data-testid="missing-documents-view"
        >
            <InformationSVG className={pendingViewStyles.InformationSVG} />
            <div className={pendingViewStyles.title}>
                <FormattedMessage {...messages.missingDocsTitle} />
            </div>

            <div
                className={classNames(
                    pendingViewStyles.subHeading,
                    styles.subHeading
                )}
            >
                <FormattedMessage {...messages.missingDocsSubtitle} />
            </div>

            <div className={styles.missingDocsContent}>
                <FormattedMessage
                    tagName="p"
                    {...messages.paragraph1}
                    values={{
                        businessInfoLink: <BusinessInfoLink />
                    }}
                />
                <p>
                    <a
                        href="https://www.iwoca.co.uk/finance-explained/open-banking/"
                        rel="noopener noreferrer"
                        target="_blank"
                        className={styles.link}
                    >
                        <FormattedMessage {...messages.whatIsOpenBanking} />
                    </a>
                </p>
                <FormattedMessage tagName="p" {...messages.paragraph2} />
                <FormattedMessage
                    tagName="p"
                    {...messages.paragraph3}
                    values={{
                        businessInfoLink: <BusinessInfoLink />
                    }}
                />
                <FormattedMessage tagName="p" {...messages.paragraph4} />
            </div>
            <ConfirmationButton
                className={styles.helpButton}
                onClick={openHelpModal}
                data-testid="missing-documents-help-button"
            >
                <FormattedMessage {...messages.helpButtonText} />
            </ConfirmationButton>
        </div>
    </MainSectionWrapper>
);

const BusinessInfoLink = () => (
    <IwLink to="/trading/" className={styles.link}>
        <FormattedMessage {...messages.businessInfoLinkText} />
    </IwLink>
);

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(MissingDocsView);
